module.exports = __webpack_public_path__ + "img/list_ticket.20b87125.svg";